export enum ENumberHighlightType {
  Top = "top",
  Left = "left",
  CreditRate = "creditRate",
}
